import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { useTranslation } from 'next-i18next';
import styles from '@features/categories/components/CategoriesFilterSelect/CategoriesFilterSelect.styles';
import FilterSelectState from '@features/categories/mobx/state/FilterSelectState';
import FilterSortState from '@features/categories/mobx/state/FilterSortState';
import Icon from '@components/icons/Icon';
import Radio from '@components/Radio/Radio';
import Check from '@components/icons/components/Check';
type PropsType = {
  filter: FilterSelectState | FilterSortState;
  dropdown?: boolean;
  sort?: boolean;
};
const CategoriesFilterSelect = observer(({
  filter,
  dropdown = false,
  sort = false
}: PropsType) => {
  const {
    options
  } = filter;
  const optionsIterator = Object.keys(options);
  const {
    t
  } = useTranslation(['filters']);
  const isWithImage = useMemo(() => optionsIterator.every(optionId => !!options[optionId].featureImageUrl), []);
  const renderWithoutImage = () => optionsIterator && optionsIterator.map((optionId, index) => {
    const isActive = optionId === filter.value;
    const label = sort ? t(optionId) : options[optionId].name || optionId;
    const handleClick = active => filter.setValue(active ? optionId : '');
    return <div sx={styles.radioContainer} key={optionId}>
          <Radio active={isActive} value={optionId} onChange={handleClick} showError={false} addSx={styles.radio(dropdown, index)} cy="CategoriesFilterSelectItem">
            {label}
          </Radio>
        </div>;
  });
  const renderWithImage = () => <ul sx={styles.filterList}>
      {optionsIterator && optionsIterator.map(optionId => {
      const isActive = optionId === filter.value;
      const {
        name,
        featureImageUrl: imageUrl
      } = options[optionId];
      const handleClick = () => filter.setValue(isActive ? '' : optionId);
      return <li key={optionId} sx={styles.filterElement(dropdown)}>
              <button type="button" sx={styles.buttonWrapper} onClick={handleClick}>
                <span sx={styles.imgWrapper(isActive, dropdown)}>
                  {isActive && <span sx={styles.checkIcon(isActive)}>
                      <Icon size={dropdown ? '16px' : '24px'}>
                        <Check />
                      </Icon>
                    </span>}
                  {imageUrl && <ResponsiveImage image={imageUrl} width={40} height={40} alt={name || optionId} objectFit="fill" />}
                </span>
                <span>{name || optionId}</span>
              </button>
              {/* {typeof option.count !== 'undefined' && <span sx={styles.count}>{option.count}</span>} */}
            </li>;
    })}
    </ul>;
  return <div data-cy="CategoriesFilterSelect" sx={styles.radioGroup}>
      {isWithImage ? renderWithImage() : renderWithoutImage()}
    </div>;
});
export default CategoriesFilterSelect;